import React from 'react';
import PropTypes from 'prop-types';
import { Element } from 'react-scroll';
import { Player } from '@lottiefiles/react-lottie-player';

import GlobalComponentContainer from '../GlobalComponentContainer';
import ContentDivider from '../shared/ContentDivider';
import DesktopAndTabletContainer from '../../shared/DesktopAndTabletContainer';
import DesktopContainer from '../../shared/DesktopContainer';
import MobileContainer from '../../shared/MobileContainer';
import ConditionalWrapper from '../../shared/conditionalWrapper/ConditionalWrapper';
import LazyLoadImg from '../shared/LazyLoadImg';

import { sizedImageShape, animationShape } from '../../../types';
import TabletAndMobileContainer from '../../shared/TabletAndMobileContainer';

const FeaturedContentImageComponent = ({
  altText,
  featuredImage,
  featuredImageMobile,
  featuredText,
  hasContentDivider,
  parentPageTitle,
  parentPageUrl,
  prettyUrlTitle,
  shortDescription,
  title,
  animation
}) => {
  return (
    <section className="section-white">
      <div className="container-fluid">
        <div className="featured-image section-gutter">
          <ConditionalWrapper
            condition={prettyUrlTitle}
            wrapper={children => <Element name={prettyUrlTitle}>{children}</Element>}
          >
            <GlobalComponentContainer
              {...{ parentPageTitle, parentPageUrl, shortDescription, title }}
            />
            <>
              {featuredImageMobile?.url && (
                <MobileContainer>
                  <LazyLoadImg src={featuredImageMobile} alt={altText || title} />
                </MobileContainer>
              )}
              {featuredImage?.url && (
                <DesktopAndTabletContainer>
                  <LazyLoadImg src={featuredImage} alt={altText || title} />
                </DesktopAndTabletContainer>
              )}
            </>
            {animation && animation.animationUrl && (
              <>
                <DesktopContainer>
                  <Player
                    src={animation.animationUrl}
                    background={animation.backgroundColor}
                    speed={animation.speed}
                    style={{ width: animation.width, height: animation.height }}
                    autoplay={animation.autoplay}
                    loop={animation.loop}
                    hover={animation.hover}
                    mode={animation.playMode}
                  />
                </DesktopContainer>
                <TabletAndMobileContainer>
                  <Player
                    src={animation.animationUrl}
                    background={animation.backgroundColor}
                    speed={animation.speed}
                    style={{ width: animation.deviceWidth, height: animation.deviceHeight }}
                    autoplay={animation.autoplay}
                    loop={animation.loop}
                    hover={animation.hover}
                    mode={animation.playMode}
                  />
                </TabletAndMobileContainer>
              </>
            )}
            <div className="content">
              <div dangerouslySetInnerHTML={{ __html: featuredText }} />
            </div>
          </ConditionalWrapper>
        </div>
        {hasContentDivider && <ContentDivider />}
      </div>
    </section>
  );
};

FeaturedContentImageComponent.defaultProps = {
  altText: '',
  hasContentDivider: false,
  parentPageTitle: '',
  parentPageUrl: '',
  prettyUrlTitle: '',
  shortDescription: '',
  animation: {}
};

FeaturedContentImageComponent.propTypes = {
  altText: PropTypes.string,
  featuredImage: sizedImageShape.isRequired,
  featuredImageMobile: sizedImageShape.isRequired,
  featuredText: PropTypes.string.isRequired,
  hasContentDivider: PropTypes.bool,
  parentPageTitle: PropTypes.string,
  parentPageUrl: PropTypes.string,
  prettyUrlTitle: PropTypes.string,
  shortDescription: PropTypes.string,
  title: PropTypes.string.isRequired,
  animation: animationShape
};

export default FeaturedContentImageComponent;
